import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { MODEL_OPTIONS } from './models';

interface Props {
  model: string;
  onModelChange: (model: string) => void;
  promptText: string;
  onPromptChange: (text: string) => void;
  disabled?: boolean;
}

// Shared editor used by both the "Re-generate" dialog (clones into a new
// script) and the "Generate" quick-action dialog (runs the existing saved
// script): an LLM model picker + the editable prompt textarea. Keeps the two
// flows visually identical and in sync.
export default function PromptModelFields({ model, onModelChange, promptText, onPromptChange, disabled = false }: Props) {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Typography variant="body2" fontWeight={600}>Model</Typography>
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <Select value={model} onChange={(e) => onModelChange(e.target.value)} disabled={disabled}>
            {MODEL_OPTIONS.map(m => (
              <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TextField
        value={promptText}
        onChange={(e) => onPromptChange(e.target.value)}
        fullWidth multiline minRows={14} maxRows={28}
        variant="outlined"
        disabled={disabled}
        InputProps={{ sx: { fontFamily: 'ui-monospace, monospace', fontSize: '0.78rem' } }}
      />
    </>
  );
}
